import "./drawer.js";
import "../sass/style.scss";

jQuery(document).ready(function ($) {
  objectFitImages();

  /**
   * Init
   */

  var _touch = "ontouchstart" in document ? "touchend" : "click";
  var locationHref = $(location).attr("href");
  var h = window.innerHeight ? window.innerHeight : $(window).height();
  var $header = $(".js-grads-header");
  var $main = $("#main");
  var $mainPos = $main.length && $main.offset().top;
  var $topOfWindow = $(window).scrollTop();
  var timestamp = new Date().getTime();
  var $src = $("#animation").attr("src");

  /**
   * Init render
   */

  if ($topOfWindow > 100) {
    $(".js-header").addClass("is-scrolled");
  }

  if (200 + $topOfWindow > $mainPos) {
    $(".js-grads-header").addClass("is-scolled");
  }
  /**
   *
   * gifアニメの初期化
   */
  $("#animation").attr("src", $src + "?" + timestamp);

  /**
   * Remove CharCode
   */

  var spChar = [11, 8203];

  $("body").each(function () {
    var txtBefore = $(this)[0].innerHTML;
    var txtAfter = "";
    for (var i = 0; i < txtBefore.length; i++) {
      var chr = txtBefore.charCodeAt(i);
      if (spChar.indexOf(chr) == -1) {
        txtAfter += String.fromCharCode(chr);
      }
    }
    $(this)[0].innerHTML = txtAfter;
  });

  /**
   * scroll TO
   */

  $(".js-scroll").on(_touch, function (e) {
    e.preventDefault();
    $("html,body").animate({ scrollTop: $("html").offset().top });
    return false;
  });

  /**
   * animations
   */

  // 共通の IntersectionObserver を作成する関数
  function createObserver(classToAdd, threshold = 0.2, rootMargin = "0px", childSelectors = null) {
    return new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          console.log(entry);
          if (entry.isIntersecting) {
            // 子要素のセレクタが指定されている場合
            if (childSelectors) {
              const parent = $(entry.target);
              childSelectors.forEach((selector) => {
                parent.find(selector).each(function () {
                  let timeout = $(this).data("timeout") || 300;
                  setTimeout(() => {
                    let direction = $(this).data("direction");
                    $(this).addClass(`${classToAdd} ${direction || ""}`);
                  }, timeout);
                });
              });
              // 子要素のセレクタが指定されていない場合
            } else {
              let timeout = $(entry.target).data("timeout") || 300;
              setTimeout(() => {
                let direction = $(entry.target).data("direction");
                $(entry.target).addClass(`${classToAdd} ${direction || ""}`);
              }, timeout);
            }
          }
        });
      },
      { threshold, rootMargin },
    );
  }

  // 指定のセレクタに Observer を適用する関数
  function observeElements(observer, selectors) {
    selectors.forEach((selector) => {
      $(selector).each(function () {
        observer.observe(this);
      });
    });
  }

  // 各Observerの定義
  // 各Observerの定義
  const animObserver = createObserver("animate__animated", 0.001);
  const heroObserver = createObserver("is-animated", 0.1);
  const serviceListObserver = createObserver("is-animated", 0.1);
  const slideTextParentObserver = createObserver("is-visible", 0.3, "0px", [
    ".js-slide-text",
    ".js-slide-text-right",
    ".js-bg-anim",
    ".js-slide-text-vertical",
  ]);

  const slideVoiceParentObserver = createObserver("is-visible", 0.01, "0px", [".js-slide-voice"]);

  // 監視対象を登録
  observeElements(animObserver, [".js-anim"]);
  observeElements(slideTextParentObserver, [".js-slide-text-parent"]);
  observeElements(slideVoiceParentObserver, [".js-slide-text-parent"]);
  observeElements(heroObserver, [".js-video-anim", ".js-strip-anim"]);
  observeElements(serviceListObserver, [".js-service-anim"]);

  // ホバーエフェクトを統一
  function addHoverEffect(selector) {
    $(selector).on("mouseenter", function () {
      $(this).addClass("is-hovered").removeClass("is-exiting");
    });

    $(selector).on("mouseleave", function () {
      $(this).removeClass("is-hovered").addClass("is-exiting");
      setTimeout(() => {
        $(this).removeClass("is-exiting");
      }, 600);
    });
  }

  addHoverEffect(".js-card-anim a");

  $(".js-anim-top").each(function () {
    var imagePos = $(this).offset().top;
    var direction = $(this).data("direction");
    if (imagePos < h) {
      $(this).addClass(direction);
    }
  });

  /**
   * scroll event
   */

  $(window).scroll(function () {
    var topOfWindow = $(window).scrollTop();
    if ($main.length) {
      if ($mainPos < topOfWindow + 200) {
        $(".js-grads-header").addClass("is-scolled");
      } else {
        $(".js-grads-header").removeClass("is-scolled");
      }
    }
    $(".js-anim-top").each(function () {
      var imagePos = $(this).offset().top;
      var direction = $(this).data("direction");
      if (imagePos < topOfWindow + h + 200 || imagePos < h + 200) {
        $(this).addClass(direction);
      }
    });
    if (topOfWindow > 100) {
      $(".js-header").addClass("is-scrolled");
    } else {
      $(".js-header").removeClass("is-scrolled");
    }
  });

  /**
   * Drawer
   */
  $(".js-drawer").simpleDrawer({
    fixed: true,
    btnside: "right",
    drawerside: "right",
  });

  /**
   * modal
   */

  $(".js-modal").each(function (e) {
    let $voice = $(this);
    let $modal = $voice.children(".js-modal-content");
    let $overlay = $voice.find(".js-modal-overlay");
    let $btn = $voice.find(".js-modal-btn");
    let $close = $voice.find(".js-modal-close");

    $btn.on("click", function (e) {
      e.preventDefault();
      $(this).parents(".js-modal").children(".js-modal-content").addClass("is-fadein");
    });

    $overlay.on("click", function (e) {
      e.stopPropagation();
      $(this).parent().removeClass("is-fadein");
    });
    $close.on("click", function (e) {
      e.stopPropagation();
      $(this).parent().parent().removeClass("is-fadein");
    });
  });

  $(".js-voice-modal").each(function (e) {
    let $voice = $(this);
    let $modal = $voice.children(".js-modal-content");
    let $prevBtn = $voice.find(".js-modal-prev");
    let $nextBtn = $voice.find(".js-modal-next");

    $(".js-voice-modal").last().find(".js-modal-next").addClass("is-hidden");
    $(".js-voice-modal").first().find(".js-modal-prev").addClass("is-hidden");

    $voice.on("click", function (e) {
      e.preventDefault();
      $modal.appendTo("body");
      $("body").children(".js-modal-content").addClass("is-fadein");
    });

    $prevBtn.on("click", function (e) {
      e.stopPropagation();
      $target = $(this).parent().parent().parent().prev();
      $(this).parent().parent().removeClass("is-fadein");
      $target.children(".js-modal-content").addClass("is-fadein");
      if (!$target.prev()) {
        $(this).addClass("is-hidden");
      }
    });

    $nextBtn.on("click", function (e) {
      e.stopPropagation();
      $target = $(this).parent().parent().parent().next();
      $(this).parent().parent().removeClass("is-fadein");
      $target.children(".js-modal-content").addClass("is-fadein");
    });
  });

  // イベント委譲
  $(document).on("click", ".js-modal-close, .js-modal-overlay", function (e) {
    e.stopPropagation();
    $("body").children(".js-modal-content").removeClass("is-fadein");
    $("body").children(".js-modal-content").remove();
  });

  $(".js-dropdown").each(function (e) {
    $(".js-dropdown-btn").on(_touch, function (e) {
      $this = $(this);
      $targetContent = $this.parent("dl");
      $targetContent.siblings().removeClass("is-active");
      if ($targetContent.hasClass("is-active")) {
        $targetContent.removeClass("is-active");
      } else {
        $targetContent.addClass("is-active");
      }
    });
  });

  $(".js-job-dropdown").each(function (e) {
    var $dropdown = $(this);
    var $btn = $dropdown.children(".js-job-dropdown-btn");
    var $targetContent = $dropdown.children(".js-job-dropdown-content");

    $btn.on("click", function (e) {
      e.preventDefault();

      // 他の全てのドロップダウンからis-activeクラスを削除
      $(".js-job-dropdown-content").not($targetContent).removeClass("is-active");
      $(".js-job-dropdown-btn").not($btn).removeClass("is-active");

      // クリックされたドロップダウンのis-activeクラスを切り替え
      $btn.toggleClass("is-active");
      $targetContent.toggleClass("is-active");
    });
  });

  var swiper = undefined;
  var winW = window.innerWidth;
  var swiperElement = document.getElementById("slider");
  if (swiperElement) {
    var swiperWrapper = swiperElement.getElementsByClassName("swiper-wrapper");
    var swiperSlide = swiperElement.getElementsByClassName("swiper-slide");
    var options = {
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    };

    function initSwiper() {
      if (swiperElement) {
        var screenWidth = window.innerWidth;
        if (screenWidth < 992 && swiper == undefined) {
          swiper = new Swiper(".swiper-container", options);
        } else if (screenWidth > 991 && swiper != undefined) {
          swiper.destroy();
          swiper = undefined;
          for (var i = 0; i < swiperWrapper.length; i++) {
            swiperWrapper[i].removeAttribute("style");
          }
          for (var i = 0; i < swiperSlide.length; i++) {
            swiperSlide[i].removeAttribute("style");
          }
        }
      }
    }

    $(window).on("load resize", function () {
      initSwiper();
    });
  }

  if ($(".interviewSwiper").length) {
    var mySwiper = new Swiper(".interviewSwiper", {
      spaceBetween: 8,
      // width: 365,
      slidesPerView: 1.05,
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        1280: {
          slidesPerView: 3.8,
        },
        1024: {
          slidesPerView: 3.2,
        },
        640: {
          spaceBetween: 10,
          slidesPerView: 2.6,
        },
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        slideChange: function (index) {
          if (mySwiper) {
            $(".swiper-pagination__wrapper").removeClass(`is-active-1`);
            $(".swiper-pagination__wrapper").removeClass(`is-active-2`);
            $(".swiper-pagination__wrapper").removeClass(`is-active-3`);
            $(".swiper-pagination__wrapper").removeClass(`is-active-4`);
            $(".swiper-pagination__wrapper").removeClass(`is-active-5`);
            $(".swiper-pagination__wrapper").removeClass(`is-active-6`);
            $(".swiper-pagination__wrapper").addClass(`is-active-${mySwiper.realIndex}`);
          }
        },
      },
    });
  }
  var movie = undefined;
  var winW = window.innerWidth;
  var movieElement = document.getElementById("movie");
  if (movieElement) {
    var movieWrapper = movieElement.getElementsByClassName("swiper-wrapper");
    var movieSlide = movieElement.getElementsByClassName("swiper-slide");
    var movieOptions = {
      loop: true,
      centeredSlides: true,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };

    function initMovie() {
      if (movieElement) {
        movie = new Swiper(".movie-container", movieOptions);
      }
    }

    $(window).on("load resize", function () {
      initMovie();
    });
  }

  const $spMenuItems = $(".js-sp-menu .menu-item-has-children");

  // 親メニューのクリックでドロップダウンを制御
  $spMenuItems.each(function () {
    const $menuItem = $(this);
    const $link = $menuItem.find("> a"); // 直下のaタグを取得
    // $link.on("click", function (event) {
    //   event.preventDefault();
    // });
  });

  $spMenuItems.on("click", function (event) {
    if ($(event.target).is($spMenuItems.find(".c-dropdownBtn"))) {
      const $this = $(this);

      // メニューの開閉をトグル
      if ($this.hasClass("menu-open")) {
        $this.removeClass("menu-open");
      } else {
        $spMenuItems.removeClass("menu-open"); // 他のメニューを閉じる
        $this.addClass("menu-open"); // 現在のメニューを開く
      }
    }
  });

  const $menuItems = $(".js-header .menu-item-has-children");

  // 親メニューのクリックでドロップダウンを制御
  $menuItems.each(function () {
    const $menuItem = $(this);
    const $link = $menuItem.find("> a"); // 直下のaタグを取得
  });

  // メニューを開く処理
  $menuItems.on("mouseenter", function () {
    const $this = $(this);
    let enterTime = Date.now();
    $this.data("enter-time", enterTime);

    $menuItems.each(function () {
      clearTimeout($(this).data("open-timer"));
      clearTimeout($(this).data("close-timer"));
    });

    const otherMenuOpen = $menuItems.is(".menu-open");

    // 現在のメニューを開く
    // if (!otherMenuOpen) {

    $this.data(
      "open-timer",
      setTimeout(() => {
        const timeDiff = Date.now() - $this.data("enter-time");
        const isCurrentlyOpen = $this.hasClass("menu-open");
        const otherMenuOpen = $menuItems.is(".menu-open");

        if (Date.now() - $this.data("enter-time") >= 250) {
          $menuItems.not($this).removeClass("menu-open");
        }
        setTimeout(() => {
          if (Date.now() - $this.data("enter-time") >= 250) {
            if (!$this.hasClass("menu-open")) {
              $this.addClass("menu-open");
            }
          }
        }, 100);
      }, 300),
    );
  });

  // メニューを閉じる処理
  $menuItems.on("mouseleave", function (event) {
    const $relatedTarget = $(event.relatedTarget);
    const $this = $(this);
    let leadveTime = Date.now();
    $this.data("leave-time", leadveTime);

    // 閉じるタイマーを設定
    $this.data(
      "close-timer",
      setTimeout(() => {
        // if (Date.now() - $this.data("leave-time") >= 500) {
        $this.removeClass("menu-open");
        // }
      }, 500),
    );
  });

  // 子メニュー内にマウスが入ったら閉じるタイマーを解除
  $menuItems.find(".sub-menu").on("mouseenter", function () {
    const $parentItem = $(this).closest(".menu-item");
    clearTimeout($parentItem.data("close-timer"));
    clearTimeout($parentItem.data("open-timer"));
  });

  // メニュー外をクリックしたらすべてのメニューを閉じる
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".menu").length) {
      $menuItems.removeClass("menu-open");
    }
  });

  /**
   * parallax
   */
  var rellax = new Rellax(".rellax");

  // window.addEventListener("resize", function () {
  //   const element = document.querySelector(".p-top-company__bg");
  //   const vw = window.innerWidth;
  //   const vh = window.innerHeight;
  //   const height = Math.max(vw, vh);
  //
  //   element.style.top = `calc(-${vh - vw}px)`;
  // });
  //
  // // 初期ロード時の実行
  // window.dispatchEvent(new Event("resize"));
});
